const CACHE_PREFIX = "apicache:";

export function getCache(key) {
  try {
    const raw = sessionStorage.getItem(CACHE_PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed || null;
  } catch (_) {
    return null;
  }
}

export function setCache(key, data, ttlMs) {
  try {
    const value = { data, timestamp: Date.now(), ttlMs: ttlMs || 0 };
    sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify(value));
  } catch (_) {}
}

export function isFresh(entry) {
  if (!entry || !entry.timestamp) return false;
  if (!entry.ttlMs || entry.ttlMs <= 0) return false;
  return Date.now() - entry.timestamp < entry.ttlMs;
}

export function clearCache(key) {
  try {
    sessionStorage.removeItem(CACHE_PREFIX + key);
  } catch (_) {}
}


